import { PageBlockType } from "@next-platform/packages-ts-types";
/**
 * Drops committed recommendation rows and asks the scheduler to load them
 * again. Category rows stay as they are: a viewer-id change does not change
 * their request.
 */
export default function restartRecommendationRows({ blocks, applicationId, scheduler, eligibilityByBlockKey, setRowStates, }) {
    const recommendationBlocks = blocks.filter((block) => block.type === PageBlockType.Recommendation);
    if (recommendationBlocks.length === 0) {
        return;
    }
    setRowStates((previousStates) => {
        let didChange = false;
        const nextStates = new Map(previousStates);
        for (const block of recommendationBlocks) {
            const existing = nextStates.get(block.key);
            if (!existing || existing.status === "idle") {
                continue;
            }
            nextStates.set(block.key, { status: "idle", block: existing.block });
            didChange = true;
        }
        return didChange ? nextStates : previousStates;
    });
    for (const block of recommendationBlocks) {
        scheduler.invalidate(block.key);
        const eligibility = eligibilityByBlockKey.get(block.key);
        if (eligibility && applicationId !== null) {
            scheduler.report(block.key, eligibility);
        }
    }
}
